<template>
  <div class="content dash-con">
    <div class="md-layout">
      <div class="w-full">
        <div class="mt-4">
          <SiteReportSection />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SiteReportSection } from "@/components";

export default {
  name: "SiteReportPage",
  components: {
    SiteReportSection
  }
};
</script>

<style scoped>
.dash-con {
  padding: 30px 30px !important;
}

@media (max-width: 640px) {
  .dash-con {
    padding: 30px 0px 30px 17px !important;
  }
}
</style>
